// extracted by mini-css-extract-plugin
export default {"btop":"_38b6e7cea1 c12c045309 _742d356990","icon":"_5bfe05f154 a1aed97c21","btoppink":"_3f2594117a d06556fdba"};